export default __webpack_public_path__ + "static/media/enFaq.f0e77f88.pdf";